import React, { lazy, Suspense } from "react";
import {
     Route,
     Routes,
     BrowserRouter,
     Navigate,
     Outlet,
} from "react-router-dom";
import Application from "../components/pages/Application";
import { PublicRoute, PrivateRoute } from "./RouteTypes";
import UiRoutes from "./UiRoutes";
import ScrollToTop from "../components/common/ScrollToTop";

import MainWrapper from "../components/_uiMocks/MainWrapper";
import Locations from "../components/_uiMocks/pages/locations/Locations";
import { SignInWrapper } from "../components/_uiMocks/pages/auth/SignInWrapper";
import { OtpVerifyWrapper } from "../components/_uiMocks/pages/auth/OtpVerifyWrapper";
import { ForgetPasswordWrapper } from "../components/_uiMocks/pages/auth/ForgetPasswordWrapper";
import ResetPasswordWrapper from "../components/_uiMocks/pages/auth/ResetPasswordWrapper";
import DashboardWrapper from "../components/pages/dashboard/DashboardWrapper";

import ComponentCatalogue from "../components/_uiMocks/pages/ComponentCatalogue";

import LookupTableWrapper from "../components/pages/lookupTable/LookupTableWrapper";
import CreateLookupTable from "../components/pages/lookupTable/CreateLookupTable";
import EditLookupTable from "../components/pages/lookupTable/EditLookupTable";

import FactTableWrapper from "../components/pages/factTable/FactTableWrapper";
import CreateFactTable from "../components/pages/factTable/CreateFactTable";
import EditFactTable from "../components/pages/factTable/EditFactTable";
import DataTableWrapper from "../components/pages/dataManagment/DataUploadwrapper";

import DataTemplatesWrapper from "../components/pages/dataTemplates/DataTemplatesWrapper";
import CreateDataTemplates from "../components/pages/dataTemplates/CreateDataTemplates";
import EditDataTemplates from "../components/pages/dataTemplates/EditDataTemplates";

import IncentiveTableWrapper from "../components/pages/Incentive/IncentiveTableWrapper";
import CreateIncentive from "../components/pages/Incentive/CreateIncentive";

import OtpVerification from "../components/pages/auth/forms/OtpVerification";
import ForgetPassword from "../components/pages/auth/forms/ForgetPassword";
import ResetPassword from "../components/pages/auth/forms/ResetPassword";
import Reports from "../components/pages/reports/Reports";
import { ReportsWrapper } from "../components/pages/reports/ReportsWrapper";
import SalesDataManagementWrapper from "../components/pages/salesDataManagement/SalesDataManagementWrapper";
import AreaManagementWrapper from "../components/pages/participantManagement/areas/AreaManagementWrapper";
import AddArea from "../components/pages/participantManagement/areas/forms/AddArea";
import DealerManagementWrapper from "../components/pages/participantManagement/dealers/DealerManagementWrapper";
import AddDealer from "../components/pages/participantManagement/dealers/forms/AddDealer";
import ParticipantsManagementWrapper from "../components/pages/participantManagement/participants/ParticipantsManagementWrapper";
import AddParticipants from "../components/pages/participantManagement/participants/forms/AddParticipants";
import RetailWinnersWrapper from "../components/pages/retailSales/winners/RetailWinnersWrapper";
import AddWinnersWrapper from "../components/pages/retailSales/winners/AddWinnersWrapper";
import RetailDealersWrapper from "../components/pages/retailSales/dealers/RetailDealersWrapper";
import RetailJobTitlesWrapper from "../components/pages/retailSales/jobTitles/RetailJobTitlesWrapper";
import RetailActivationReportWrapper from "../components/pages/retailSales/reports/RetailActivationReportWrapper";
import CxWinnersWrapper from "../components/pages/cxAlwaysInTouch/winners/CxWinnersWrapper";
import CxAddWinnersWrapper from "../components/pages/cxAlwaysInTouch/winners/CxAddWinnersWrapper";
import CxActivationReportWrapper from "../components/pages/cxAlwaysInTouch/reports/CxActivationReportWrapper";
import OptimumFrictionAccreditationWrapper from "../components/pages/optimumFriction/accreditation/OptimumFrictionAccreditationWrapper";
import OptimumFrictionReportWrapper from "../components/pages/optimumFriction/reports/OptimumFrictionReportWrapper";
import LcvParticipantUploadWrapper from "../components/pages/lcv/participants/LcvParticipantUploadWrapper";
import LcvOrderUploadWrapper from "../components/pages/lcv/orders/LcvOrderUploadWrapper";
import LcvPrizePotWrapper from "../components/pages/lcv/prizePot/LcvPrizePotWrapper";
import LcvManualPrizeWinsWrapper from "../components/pages/lcv/manualPrizeWins/LcvManualPrizeWinsWrapper";
import LcvDealerReportWrapper from "../components/pages/lcv/reports/LcvDealerReportWrapper";
import LcvGameReportWrapper from "../components/pages/lcv/reports/LcvGameReportWrapper";

export default function MainRoutes() {
     return (
          <ScrollToTop>
               <Routes>
                    {/* Public routes */}
                    <Route
                         path="/"
                         element={
                              <PublicRoute>
                                   <Application />
                              </PublicRoute>
                         }
                    />
                    <Route
                         path="/auth/*"
                         element={
                              <>
                                   <Outlet />
                              </>
                         }
                    >
                         <Route
                              path="otp-verification/:id/:userId"
                              element={
                                   <PublicRoute>
                                        <OtpVerification />
                                   </PublicRoute>
                              }
                         />

                         <Route
                              path="forgot-password"
                              element={
                                   <PublicRoute>
                                        <ForgetPassword />
                                   </PublicRoute>
                              }
                         />

                         <Route
                              path="set-password"
                              element={
                                   <PublicRoute>
                                        <ResetPassword />
                                   </PublicRoute>
                              }
                         />
                    </Route>

                    {/* Public routes */}
                    {/* Private routes */}

                    <Route path="/app/*" element={<PrivateRoute />}>
                         <Route
                              path="dashboard"
                              element={<DashboardWrapper />}
                         />
                         <Route path="participant" element={<>participant</>} />
                         <Route
                              path="lookup-data-manage"
                              element={<LookupTableWrapper />}
                         />
                         <Route
                              path="lookup-data-manage/add"
                              element={<CreateLookupTable />}
                         />
                         <Route
                              path="lookup-data-manage/edit/:id"
                              element={<EditLookupTable />}
                         />

                         <Route
                              path="data-templates-manage"
                              element={<DataTemplatesWrapper />}
                         />
                         <Route
                              path="data-templates-manage/add"
                              element={<CreateDataTemplates />}
                         />
                         <Route
                              path="data-templates-manage/edit/:id"
                              element={<EditDataTemplates />}
                         />

                         <Route
                              path="fact-data-manage"
                              element={<FactTableWrapper />}
                         />
                         <Route
                              path="fact-data-manage/add"
                              element={<CreateFactTable />}
                         />
                         <Route
                              path="fact-data-manage/edit/:id"
                              element={<EditFactTable />}
                         />
                         <Route
                              path="data-upload"
                              element={<DataTableWrapper />}
                         />

                         <Route path="test" element={<></>} />

                         <Route
                              path="incentive-data-manage"
                              element={<IncentiveTableWrapper />}
                         />

                         <Route
                              path="incentive-data-manage/add/:id?"
                              element={<CreateIncentive />}
                         />
                          <Route
                              path="reports"
                              element={<ReportsWrapper />}
                         />
                         <Route
                              path="sales-data-manage"
                              element={<SalesDataManagementWrapper />}
                         />
                         <Route
                              path="areas"
                              element={<AreaManagementWrapper />}
                         /> 
                         <Route
                              path="area-data-manage/add"
                              element={<AddArea />}
                         />
                         <Route
                              path="dealers"
                              element={<DealerManagementWrapper />}
                         /> 
                         <Route
                              path="dealer-data-manage/add"
                              element={<AddDealer/>}
                         />
                         <Route
                              path="participants"
                              element={<ParticipantsManagementWrapper />}
                         /> 
                         <Route
                              path="participant-data-manage/add"
                              element={<AddParticipants/>}
                         />
                         <Route
                              path="retail-sales-winners"
                              element={<RetailWinnersWrapper />}
                         />
                         <Route
                              path="retail-sales-winners/add"
                              element={<AddWinnersWrapper />}
                         />
                         <Route
                              path="retail-sales-dealers"
                              element={<RetailDealersWrapper />}
                         />
                         <Route
                              path="retail-sales-job-titles"
                              element={<RetailJobTitlesWrapper />}
                         />
                         <Route
                              path="retail-sales-report"
                              element={<RetailActivationReportWrapper />}
                         />
                         <Route
                              path="cx-always-in-touch-winners"
                              element={<CxWinnersWrapper />}
                         />
                         <Route
                              path="cx-always-in-touch-winners/add"
                              element={<CxAddWinnersWrapper />}
                         />
                         <Route
                              path="cx-always-in-touch-report"
                              element={<CxActivationReportWrapper />}
                         />
                         <Route
                              path="optimum-friction-accreditation"
                              element={<OptimumFrictionAccreditationWrapper />}
                         />
                         <Route
                              path="optimum-friction-report"
                              element={<OptimumFrictionReportWrapper />}
                         />
                         <Route
                              path="lcv-participant-upload"
                              element={<LcvParticipantUploadWrapper />}
                         />
                         <Route
                              path="lcv-order-upload"
                              element={<LcvOrderUploadWrapper />}
                         />
                         <Route
                              path="lcv-prize-pot"
                              element={<LcvPrizePotWrapper />}
                         />
                         <Route
                              path="lcv-physical-prizes"
                              element={<LcvManualPrizeWinsWrapper />}
                         />
                         <Route
                              path="lcv-dealer-report"
                              element={<LcvDealerReportWrapper />}
                         />
                         <Route
                              path="lcv-game-report"
                              element={<LcvGameReportWrapper />}
                         />
                         

                         {/* <Route path="*" element={<Navigate to="/app/home" />} /> */}
                    </Route>
                    {/* Private routes */}
                    <Route path="/ui/*" element={<MainWrapper />} />
                    <Route
                         path="/component-catalogue"
                         element={<ComponentCatalogue />}
                    />
                    <Route path="otp-verify" element={<OtpVerifyWrapper />} />
                    <Route
                         path="forget-password"
                         element={<ForgetPasswordWrapper />}
                    />
                    <Route
                         path="reset-password"
                         element={<ResetPasswordWrapper />}
                    />
               </Routes>
          </ScrollToTop>
     );
}
